module.exports = "../images/icon-discover.svg?v=de61b14";